import { CROSS_SINGLE_AND_MULTI_QUERY } from 'query/query'
import { EligibleVariable } from 'hooks/useSegmentsBy'
import { SortDirection } from './sort'

export enum Segment {
  LowValueTraditionals = 58285,
  BrandAgnosticDigitals = 58280,
  SupportSeekers = 58286,
  Pragmatics = 58283,
  BrandEnthusiasts = 58282,
  DigitallyReceptive = 58284,
  HighSpecPremium = 58281,
}

export const incomeChartTitle = 'Income'

export const incomeProps = {
  title: incomeChartTitle,
  secondaryVariable: EligibleVariable.INCOME,
  linkText: 'Go to Shopper Profiles to see full list of demographics',
  to: '/shoppers/demographics#demographics-income',
  locationCardTitle: 'Purchase Drivers',
  sortState: { index: 0, direction: SortDirection.desc },

  columnHeaders: [
    { name: 'Low', code: 6624 },
    { name: 'Medium Low', code: 6625 },
    { name: 'Medium High', code: 6626 },
    { name: 'High', code: 6627 },
    { name: 'Prefer not to say', code: 6628 },
  ],
  type: 'incomeDemographics',
  vars: {
    primaryVar: 'shopperClusterSegmentation',
    secondaryVar: EligibleVariable.INCOME,
  },
}

export const householdCompositionChartTitle = 'Household composition'

export const householdCompositionProps = {
  title: householdCompositionChartTitle,
  secondaryVariable: EligibleVariable.HOUSEHOLD_COMPOSITION,
  linkText: 'Go to Shopper Profiles to see full list of demographics',
  to: '/shoppers/demographics#demographics-household-composition',
  locationCardTitle: 'Purchase Drivers',
  sortState: { index: 0, direction: SortDirection.desc },

  columnHeaders: [
    { name: '1 adult, no kids', code: 61911 },
    { name: '1 adult with kid(s)', code: 61912 },
    { name: '2 adults, no kids', code: 61913 },
    { name: '2 adults with kid(s)', code: 61914 },
    { name: '3+ adults with/without kid(s)', code: 61915 },
  ],
  type: 'houseHoldComposition',
  vars: {
    primaryVar: 'shopperClusterSegmentation',
    secondaryVar: EligibleVariable.HOUSEHOLD_COMPOSITION,
  },
}

export const adTriggerChartTitle = 'Most influential ad triggers'

export const adTriggerConfigOptions = {
  title: adTriggerChartTitle,
  secondaryVariable: EligibleVariable.AD_TRIGGERS,
  linkText: 'Go to Shopper Touchpoints to see more on media triggers',
  to: '/shoppers/mediaTriggers#advertising-triggers',
  locationCardTitle: adTriggerChartTitle,
  query: CROSS_SINGLE_AND_MULTI_QUERY,
  answerCodes: [1, 2, 3, 4, 5, 13, 14, 17, 18, 19],

  columnHeaders: [
    { name: 'Advertising on TV', code: 14117 },
    { name: 'Advertising in magazine / newspaper', code: 14118 },
    { name: 'Advertising on social media', code: 14119 },
    { name: 'Advertising online', code: 14120 },
    { name: 'Advertising on radio', code: 14121 },
    { name: 'Advertising in print retailer leaflets', code: 14122 },
    { name: 'Advertising in digital retailer leaflets', code: 122042 },
    { name: 'Advertising on video streaming services', code: 122041 },
    { name: 'Advertising sponsorship, e.g. of sports team, event or similar', code: 135364 },
    { name: 'Advertising elsewhere', code: 14123 },
  ],
  type: 'adTriggers',
  vars: {
    primaryVar: 'shopperClusterSegmentation',
    secondaryVar: EligibleVariable.AD_TRIGGERS,
  },
}

export const purchaseReasonsChartTitle = 'Reasons to purchase from a retailer'

export const purchaseReasonsConfigOptions = {
  title: purchaseReasonsChartTitle,
  secondaryVariable: EligibleVariable.RETAILER_DRIVER,
  linkText: 'Go to Retailer Perceptions to see more on purchase reasons',
  to: '/retailers/purchaseReason#purchase-reason',
  locationCardTitle: 'Reasons to purchase from retailer',
  query: CROSS_SINGLE_AND_MULTI_QUERY,

  columnHeaders: [
    { name: 'Knowledgeable staff', code: 20026 },
    { name: 'Stock availability', code: 20027 },
    { name: 'Their prices / promotions', code: 20028 },
    { name: 'Ability to pay over time', code: 20029 },
    { name: 'Range of products', code: 20030 },
    { name: 'Can touch the product (offline purchase)', code: 20031 },
    { name: 'Ease of finding products', code: 20032 },
    { name: 'Convenience', code: 20033 },
    { name: 'After-sales support', code: 20034 },
    { name: 'Fast delivery', code: 20035 },
    { name: 'Installation service (MDA products only)', code: 20036 },
    { name: 'Free delivery', code: 20037 },
    { name: 'Support with setup / content transfer from old mobile', code: 20038 },
    { name: 'Network quality', code: 20039 },
    { name: 'Rewards / offers for loyal customers', code: 20040 },
    { name: 'To combine several services from the same provider', code: 20041 },
    { name: 'Other reason', code: 20042 },
    { name: 'Ease of comparing products', code: 47992 },
    { name: 'Product review listings', code: 47993 },
    { name: 'Detailed product information / images', code: 47994 },
  ],
  type: 'PurchaseReasonsTable',
  vars: {
    primaryVar: 'shopperClusterSegmentation',
    secondaryVar: EligibleVariable.RETAILER_DRIVER,
  },
}
